export default __webpack_public_path__ + "static/media/photo.e80097ed.svg";